module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Jack Compton’s Luck")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aboutAuthorPage",
    attrs: {
      "id": "ata01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page05"
    }
  }, [_c('h2', {
    staticClass: "aboutAuthorHead"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("PAULA MARSHALL,")])])]), _c('p', {
    staticClass: "aboutAuthorText"
  }, [_c('span', [_vm._v("married with three children, has had a varied life. She began her career in a large library and ended it as a senior academic in charge of history in a polytechnic. She has traveled widely, has been a swimming coach and has appeared on television in "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("University Challenge")])]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Mastermind.")])]), _vm._v(" She has always wanted to write, and likes her novels to be full of adventure and humor.")])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page05"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1bbb2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jackcomptonsluck_ata01.vue
// module id = 66
// module chunks = 0